import {AbstractModel} from "../abstract-model";
import {User} from '../user';
import {Activity} from './activity';

export class ActivityComment extends AbstractModel {
  id: number | null = null;
  sender: User | null = null;
  activity: Activity | null = null;
  message!: string;
  createdAt!: Date;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.sender) {
      this.sender = new User().deserialize(input.sender);
    }

    if (input.activity) {
      this.activity = new Activity().deserialize(input.activity);
    }

    return this;
  }
}
